export enum EDeliveryMode {
  digital = 1,
  pickup = 2,
  physical = 3
}
